import React, { useState, useRef, useEffect} from 'react'
import { AgGridReact } from 'ag-grid-react';
import '../../../../../styles/ag-custom.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import axios from '@fuse/utils/axios';
import { useRouter } from '@fuse/hooks';
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations';
import FuseLoading from '@fuse/core/FuseLoading';

function Activities() {
  const gridRef = useRef();
  const router = useRouter();
  const {id} = router.params;
  
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);
  const [rowData1, setRowData1] = useState(null);
  const [loading, setLoading ] = useState(false);

  const tableHeaders1 = [
    {
      field: "action_id",
      headerName: "Action Id",
      headerComponent:  CustomFilter
    },
    {
      field: "ticket_id",
      headerName: "Ticket Id",
      headerComponent:  CustomFilter
    },
    {
      field: "action_date_and_time",
      headerName: "Action date and time",
      headerComponent:  CustomFilter,
      minWidth: 250
    },
    {
      field: "action",
      headerName: "Action",
      headerComponent:  CustomFilter
    },
    {
      field: "field_name",
      headerName: "Field Name",
      headerComponent:  CustomFilter
    },
    {
      field: "previous_value",
      headerName: "Previous value",
      headerComponent:  CustomFilter
    },
    {
      field: "current_value",
      headerName: "Current value",
      headerComponent:  CustomFilter
    },
    {
      field: 'name',
      headerName: 'Name',
      headerComponent:  CustomFilter
    },
    {
      field: 'description',
      headerName: 'Description',
      headerComponent:  CustomFilter
    },
    {
      field: 'user_role',
      headerName: 'User Role',
      headerComponent:  CustomFilter
    }
  ];

  const action_to_color = {
    "CREATED": "green",
    "UPDATED": "orange",
    "ARCHIVED": "red",
    "RESTORED": "blue",
    'DELETED': "red"
  }
  function formatLogs(data) {
		let {length} = data
		return data.map((item) => {
			const obj = {
				id: item.id,
				action_id: `act${length}`,
				action_date_and_time: item.created_at,
				ticket_id: item.service_request ? item.service_request.ticket_id : item.ticket_id,
				name: item.user_name,
				action: item.action_name,
				description: item.comment,
				previous_value: item.previous_data,
				current_value: item.current_data,
				field_name: item.action_field_name,
				user_role: item.user_role_name,
				asset_serial_number: item.asset_serial_number || 'N/A'
			}
			length--;
			return obj
		})
	}

  const onGridReady = params => {
		// Following line to make the currently visible columns fit the screen  
		params.api.sizeColumnsToFit();

		// Following line dynamic set height to row on content
		params.api.resetRowHeights();
	};

  function cellRendererFrameworkFramework(params){
    if(params.colDef.field === "action"){
      return (
          <span style={{
            color: action_to_color[params.value],
            fontWeight: 'bold'
          }}>{params.value}</span>
      )
    }
      return(
        <>{params.value}</>
      )
    
  }
 
  function fetchActivities(){
    setLoading(true)
    axios.get(`/service/fetch-service-request-activities/${id}`).then((res)=>{
      setRowData1(formatLogs(res.data.data.activities))
    }).catch((err) => {
      console.log(err)
    }).finally(()=>setLoading(false))
  }

  useEffect(()=>{
    fetchActivities()
  },[]);

  return (
    <>
      <div
        className="ag-theme-alpine"
        style={{
          width: "100%",
          height: windowHeight + 105,
          fontSize: '12px'
        }}
      >
        {rowData1 === null ? (
          <FuseLoading />
        ) : (
          <AgGridReact
            ref={gridRef}
                    theme="legacy"
            rowData={rowData1}
            animateRows
              onGridReady={onGridReady}
              rowHeight={30}
              headerHeight={44}
            paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
            pagination
            defaultColDef={{
              resizable: true
            }}
              columnDefs= {tableHeaders1.map(header => {
              if (header.field === 'action_date_and_time') {
                return {
                  key: header.field,
                  field: header.field,
                  headerName: header.headerName,
                  width: header.width,
                  minWidth: header.minWidth,
                  maxWidth: header.maxWidth,
                  sortable: false,
                  flex: 1,
                  filter: "agTextColumnFilter",
                  wrapText: true,
                  autoHeight: header.field === 'description',
                  // floatingFilter = {true}
                  cellRenderer: (event) => {
                    return (
                      <span>{!event.value ? event.value : getLocalTimeFromUTC(event.value)}</span>
                    )
                  },
                  // headerComponent: {header.headerComponentFramework}
                  headerComponent: (props) => (CustomFilter(props, header, gridRef))
                }
              }
                return {
                  key: header.field,
                  field: header.field,
                  headerName: header.headerName,
                  width: header.width,
                  minWidth: header.minWidth,
                  maxWidth: header.maxWidth,
                  sortable: false,
                  flex: 1,
                  filter: "agTextColumnFilter",
                  wrapText: true,
                  autoHeight: header.field === 'description',
                  // floatingFilter = {true}
                  cellRenderer: cellRendererFrameworkFramework,
                  headerComponent: (props) => (CustomFilter(props, header, gridRef))
                }
            })}
           />
        )}
      </div>
    </>
  )
}

export default Activities